import { render, staticRenderFns } from "./WordModal.vue?vue&type=template&id=4abd99d4&scoped=true"
import script from "./WordModal.vue?vue&type=script&lang=js"
export * from "./WordModal.vue?vue&type=script&lang=js"
import style0 from "./WordModal.vue?vue&type=style&index=0&id=4abd99d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd99d4",
  null
  
)

export default component.exports